import type { ViewId } from "@/shared/types/common";

export const mapOfferMessage = {
	Markets: "To add Markets, please upgrade your plan",
	Quote: "To add Quote, please upgrade your plan",
	"Advanced Quote": "To add Advanced Quote, please upgrade your plan",
	Chart: "To add Chart, please upgrade your plan",
	Monitor: "To add Monitor, please upgrade your plan",
	Screener: "To add Screener, please upgrade your plan",
	News: "To add customizable News with key word searching, filtering, sector and sentiment analysis, please upgrade to a Silver or Gold plan",
	Financials:
		"To access 10 years of financial history ( Income,   Balance Sheets, Cashflow Statements) and key investor ratios, please upgrade to a Silver or Gold plan",
	Chat: "To add Chat, please upgrade your plan",
	Elements: "To add Elements, please upgrade your plan",
	"Earnings Analysis":
		"To use the Earnings Matrix and view Earnings Revision Scores, please upgrade to a Gold plan",
	Holders: "To add Holders, please upgrade your plan",
	Backtest: "To add Backtest, please upgrade your plan",
	Navigation: "To add Navigation, please upgrade your plan",
	"Drift Forecast":
		"To use the Drift forecast and see 90 day price projections, please upgrade to a Gold plan",
	"Dark Short":
		"Market maker short positions which reveal Institutional positioning will be available to Gold members soon",
	Holdings: "SEC 13F filings will be available to Silver and Gold members soon",
	Insiders:
		"Executive awards, Insider holdings and share positions will be available to Silver and Gold members soon",
} as const satisfies Record<ViewId, string>;
